const skills = {
    sub: "Our skills",
    heading: "Your Reliable Partner in Construction Services",
    content: "Welcome to BuildX Construction, where we bring expertise, quality, and innovation to every project. From planning to execution, we ensure excellence in all aspects of construction.",
    points: [
        {
            id: 1,
            title: 'General Contracting',
            progress: 95,
        },
        {
            id: 2,
            title: 'Structural Engineering',
            progress: 90,
        },
        {
            id: 3,
            title: 'Architectural Design',
            progress: 85,
        },
        {
            id: 4,
            title: 'Project Management',
            progress: 92,
        },
    ]
};

export default skills;